module.exports = __webpack_public_path__ + "media/images/players/KOKRAK_JASON-2ba55d304dd1acb00b4ad9cbbb5e1253.png";